'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const SectorBreakdownInner = dynamic(
  () => import('@/app/components/SectorBreakdownInner'),
  { ssr: false, loading: () => (
    <div className="h-72 animate-pulse rounded-xl" style={{ backgroundColor: 'rgba(255,255,255,0.07)' }} />
  )}
);

export default function SectorBreakdown() {
  return <SectorBreakdownInner />;
}